/**
 * StatusDot — tiny coloured dot used next to labels (tenant rows, alert
 * lists). Always paired with text per design-system.md §8 — never colour
 * alone (colour-blind + PDF B/W).
 */
import { cn } from './cn';

export type DotStatus = 'good' | 'warn' | 'fail' | 'onboarding' | 'info';

export interface StatusDotProps {
  status: DotStatus;
  /** Override the default NL aria-label (e.g. "Goed", "Kritiek"). */
  label?: string;
  className?: string;
}

const STATUS_CLASS: Record<DotStatus, string> = {
  good: 'bg-pass-600',
  warn: 'bg-warn-600',
  fail: 'bg-fail-600',
  onboarding: 'bg-slate-400',
  info: 'bg-info-600',
};

const STATUS_LABEL: Record<DotStatus, string> = {
  good: 'Goed',
  warn: 'Aandacht',
  fail: 'Kritiek',
  onboarding: 'Onboarding',
  info: 'Info',
};

export function StatusDot({ status, label, className }: StatusDotProps): JSX.Element {
  return (
    <span
      role="img"
      aria-label={label ?? STATUS_LABEL[status]}
      title={label ?? STATUS_LABEL[status]}
      className={cn('inline-block h-2 w-2 rounded-full', STATUS_CLASS[status], className)}
    />
  );
}
